import {useEffect, useState} from "react";
import {useGetProductsQuery} from "@/redux-store/api/marketingApi.ts";
import {useAppSelector} from "@/redux-store/hooks.ts";
import CartList from "@/components/Checkout/CartSummary/components/CartList.tsx";

interface IDiscountApplied {
    id: string;
    name: string;
    description: string;
    code: string;
    percentageOff: number;
    fixedAmount: number | null;
    lastEdited: string;
}

interface ICartItem {
    idProduct: number;
    productName: string;
    quantity: number;
    price: number;
    stockAvailable: number;
}

interface IPaymentResponse {
    message: string;
    orderNumber: string;
    totalAmount: number;
    discountApplied: IDiscountApplied;
    cartItems: ICartItem[];
}

interface IProps {
    paymentResponse: IPaymentResponse;
}

const Cartend: React.FC<IProps> = ({ paymentResponse }) => {
    const { data } = useGetProductsQuery({});
    const [products, setProducts] = useState<ICartItem[]>([]);
    const sessionId = useAppSelector((state) => state.cart.sessionId);

    useEffect(() => {
        const getCheckoutData = async () => {
                if (data) {
                    const updatedProducts = paymentResponse?.cartItems.map((item) => {
                        const productData = data.find((product) => product.id === item.idProduct);
                        return {
                            ...item,
                            name: productData?.name || "No Name",
                            image: productData?.image || "No Image"
                        };
                    });
                    setProducts(updatedProducts);
                } else {
                    setProducts(paymentResponse?.cartItems);
                }
        };

        if (data) {
            getCheckoutData();
        }
    }, [data, sessionId]);

    return (
        <>
            {products && products.length > 0 && (
                <>
                    <CartList products={products as any} />
                </>
            )}
        </>
    );
};

export default Cartend;
